<template>
  <div v-if="products" class="rv__inner">
    <div ref="productSlider" class="rv__products-wrapper swiper-container">
      <div class="rv__products">
        <div v-for="(product, index) in products" :key="index" class="rv__product">
          <ProductCard type="TypeA" :product="product" :showWishlistIcon="false" />
        </div>
      </div>
      <div class="rv__nav rv__prev">
        <svg class="rv__prev-icon">
          <use xlink:href="#icon-prev"></use>
        </svg>
      </div>
      <div class="rv__nav rv__next">
        <svg class="rv__next-icon">
          <use xlink:href="#icon-next"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup="props">
  import { computed, toRefs, ref, onMounted } from 'vue';
  import ProductCard from '../global/product-card/index.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';

  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    products: {
      type: Object,
      required: true,
    },
  });

  const { data } = toRefs(props);

  onMounted(() => {
    new Swiper(productSlider.value, productCarousel.value);
    window.refreshYotpoData();
  });

  var productSlider = ref(null);

  const productCarousel = computed(() => {
    return {
      slidesPerView: 1.6,
      spaceBetween: 16,
      wrapperClass: 'rv__products',
      slideClass: 'rv__product',
      breakpoints: {
        768: {
          slidesPerView: 2.8,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1367: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: '.rv__next',
        prevEl: '.rv__prev',
      },
      a11y: {
        enabled: true,
      },
    };
  });
</script>
